var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.938 5.728 6.123 20.543c1.383 0 2.765.395 3.753 1.383s1.383 2.37 1.383 3.556l14.815-14.815c1.383-1.383 1.383-3.753 0-5.136-1.383-.988-3.951-.988-5.136.198zM31.012 1.185c-1.383-1.383-3.753-1.383-5.136 0L24.691 2.37c1.383-.198 2.568.395 3.556 1.383s1.383 2.37 1.383 3.556l1.383-1.185c1.185-1.58 1.185-3.753 0-4.938zM7.506 24.494c-1.185-1.185-3.16-1.383-4.543-.395l-.593 1.58-.395 1.383L0 31.803l6.321-2.37 1.58-.395c.988-1.383.79-3.358-.395-4.543z"
  })));
};
export default SvgEdit;